/**
 * Search URL params
 */
export var SEARCH_URL_PARAM_FACET = "f";
export var SEARCH_URL_PARAM_PAGE = "page";